import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import DeleteTicketMutation from '../../../../../mutations/ticketing/tickets/deleteTicketMutation';

interface UseDeleteTicketResult {
	submit: (id: string, connections?: string[]) => Promise<string>;
	loading: boolean;
	error: string | null;
}

export function useDeleteTicket(): UseDeleteTicketResult {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function submit(id: string, connections: string[] = []): Promise<string> {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				DeleteTicketMutation,
				{id, connections},
				response => {
					setLoading(false);
					resolve(response.deleteTicket.deletedTicketId);
				},
				(err, onFailure) => {
					// The seam's fallback owns the user-facing failure: a 404 on an already-deleted
					// ticket gets the non-critical not-found modal, anything else the standard error
					// modal. It returns true when a transient-network retry is already in flight, so
					// this attempt is not final and must not settle the promise.
					if (onFailure(err) === true) return;
					setLoading(false);
					const msg = err instanceof Error ? err.message : String(err);
					setError(msg);
					reject(err);
				}
			);
		});
	}

	return {submit, loading, error};
}
